<template>
  <div class="row">
    <!-- User Card -->
    <div class="col-xl-4 col-lg-5 col-md-6 col-sm-4">
      <div class="iphone-x">
        <div v-if="!iframeLoaded" class="progress-container">
          <div class="progress">
            <div class="progress-bar" role="progressbar" :style="{ width: loadingProgress + '%' }" :aria-valuenow="loadingProgress" aria-valuemin="0" aria-valuemax="100">
              {{ loadingProgress }}%
            </div>
          </div>
        </div>
        <div class="iframe-container" v-show="iframeLoaded" sandbox="allow-top-navigation allow-scripts allow-forms">
          <iframe :src="qrUserUrl" title="User QR Profile" @load="onIframeLoad" ref="userIframe"></iframe>
        </div>
      </div>
    </div>
    <div class="col-xl-8 col-lg-7 col-md-6">
      <card class="card" :title="$t('profile.editProfile')">
        <div>
          <form>
            <!-------------------------------Personal Info------------------------------->
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('profile.firstName')"
                  :placeholder="$t('profile.firstNamePlaceholder')"
                  v-model="user.name"
                />
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('profile.lastName')"
                  :placeholder="$t('profile.lastNamePlaceholder')"
                  v-model="user.surname"
                />
              </div>
              <div class="col-md-4">
                <fg-input
                  type="email"
                  :label="$t('profile.personalMail')"
                  :placeholder="$t('profile.personalMailPlaceholder')"
                  v-model="user.personal_mail"
                />
              </div>
            </div>

            <!-------------------------------Company Info------------------------------->
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('profile.company')"
                  :placeholder="$t('profile.companyPlaceholder')"
                  v-model="user.company"
                />
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('profile.title')"
                  :placeholder="$t('profile.titlePlaceholder')"
                  v-model="user.title"
                />
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('profile.businessMail')"
                  :placeholder="$t('profile.businessMailPlaceholder')"
                  v-model="user.business_mail"
                />
              </div>
            </div>
            <!-------------------------------Phone Info------------------------------->
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  :label="$t('profile.personalPhone')"
                  :placeholder="$t('profile.personalPhonePlaceholder')"
                  v-model="user.personal_phone"
                />
              </div>
              <div class="col-md-4">
                <fg-input
                  :label="$t('profile.businessPhone')"
                  :placeholder="$t('profile.businessPhonePlaceholder')"
                  v-model="user.business_phone"
                />
              </div>
              <div class="col-md-4">
                <fg-input
                  :label="$t('profile.otherPhone')"
                  :placeholder="$t('profile.otherPhonePlaceholder')"
                  v-model="user.other_phone"
                />
              </div>
            </div>
            <!-------------------------------Web Info------------------------------->
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('profile.personalWeb')"
                  :placeholder="$t('profile.personalWebPlaceholder')"
                  v-model="user.personal_web"
                />
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('profile.companyWeb')"
                  :placeholder="$t('profile.companyWebPlaceholder')"
                  v-model="user.business_web"
                />
              </div>
              <div class="col-md-4">
                <fg-input
                  type="email"
                  :label="$t('profile.otherWeb')"
                  :placeholder="$t('profile.otherWebPlaceholder')"
                  v-model="user.other_web"
                />
              </div>
            </div>
            <!-------------------------------File Info------------------------------->
            <div class="row">
              <div class="col-md-4">
                <div class="row">
                  <div class="col-8">
                    <fg-input
                      v-if="!profileImage"
                      type="file"
                      :label="$t('profile.profileImage')"
                      accept=".jpg, .png, .jpeg"
                      @change.native.prevent="handleProfileImageChange"
                    />
                    <fg-input v-else type="text" :label="$t('profile.profileImage')" :value="profileImage" style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></fg-input>
                  </div>
                  <div class="col-1">
                    <p-button type="danger" round @click.native.prevent="removeProfileImage" class="text-center ti-trash"></p-button>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <div class="col-8">
                    <fg-input
                      v-if="!backgroundImage"
                      type="file"
                      :label="$t('profile.backgroundImage')"
                      accept=".jpg, .png, .jpeg"
                      @change.native.prevent="handleBackgroundImageChange"
                    />
                    <fg-input v-else type="text" :label="$t('profile.backgroundImage')" :value="backgroundImage" style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></fg-input>
                  </div>
                  <div class="col-1">
                    <p-button type="danger" round @click.native.prevent="removeBackImage" class="text-center ti-trash"></p-button>
                  </div>
                </div>
              </div>
            </div>
            <!-------------------------------Address Info------------------------------->
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('profile.city')"
                  :placeholder="$t('profile.cityPlaceholder')"
                  v-model="user.city"
                />
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('profile.country')"
                  :placeholder="$t('profile.countryPlaceholder')"
                  v-model="user.country"
                />
              </div>
              <div class="col-md-4">
                <fg-input
                  type="number"
                  :label="$t('profile.postalCode')"
                  :placeholder="$t('profile.postalCodePlaceholder')"
                  v-model="user.postal_code"
                />
              </div>
            </div>
            <!-------------------------------Address location Info------------------------------->
            <div class="row">
              <div class="col-md-8">
                <fg-input
                  type="text"
                  :label="$t('profile.address')"
                  :placeholder="$t('profile.addressPlaceholder')"
                  v-model="user.address"
                />
              </div>
              <div class="col-md-4">
                <fg-input
                  type="email"
                  :label="$t('profile.location')"
                  :placeholder="$t('profile.locationPlaceholder')"
                  v-model="user.location"
                />
              </div>
            </div>

            <div class="text-center">
              <p-button type="info" round @click.native.prevent="updateProfile">
                {{ $t('profile.updateProfile') }}
              </p-button>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/routing_map.json";
import router from "@/router";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default { components: {
    vSelect
  },
  data() {
    return {
      user: {
        company: "",
        business_mail: "",
        personal_mail: "",
        business_phone: "",
        personal_phone: "",
        other_phone: "",
        personal_web: "",
        business_web: "",
        other_web: "",
        mail: "",
        name: "",
        surname: "",
        address: "",
        location: "",
        city: "",
        postal_code: "",
        billing: "",
        phones:[
          {
            "name": "Personal",
            "number": "1"
          },
          {
            "name": "Business",
            "number": "1"
          },
          {
            "name": "Other",
            "number": "1"
          }
        ]
      },
      profileImage: null,
      profileImageSrc: null,
      backgroundImage: null,
      backgroundImageSrc: null,
      eCatalog: null,
      imagePreview: false,
      imageUrl: null,
      userCards:[],
      maxImageSize: 5 * 1024 * 1024, // 5MB in bytes
      qrUserUrl:"onlinecardvisit.com",
      iframeLoaded: false,
      loadingProgress: 0,
      loadingInterval: null,
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
      allowedTypes: ['image/jpeg', 'image/png', 'image/jpg']
    };


  },

  watch: {
    profileImage(newValue, oldValue) {
      if (!this.imagePreview && (newValue !== oldValue)) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.profileImageSrc = value
            })
            .catch(() => {
              this.profileImageSrc = null
            })

        } else {
          this.profileImageSrc = null
        }
      }

    },
    backgroundImage(newValue, oldValue) {
      if (!this.imagePreview && (newValue !== oldValue)) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.backgroundImageSrc = value
            })
            .catch(() => {
              this.backgroundImageSrc = null
            })

        } else {
          this.backgroundImageSrc = null
        }
      }

    },
  },
  mounted() {
    this.getUser()
    this.startLoadingAnimation();
  },
  methods: {

     validateAndHandleImage(event, imageSetter, notifyCallback) {
      const file = event.target.files[0];

      // Size validation
      if (file && file.size > this.maxSize) {
        notifyCallback('top', 'right', "5MB Boyutundan Küçük Görsel Seçiniz", "warning");
        event.target.value = ''; // Clear input
        return false;
      }

      // Type validation
      if (file && !this.allowedTypes.includes(file.type)) {
        notifyCallback('top', 'right', "JPG, JPEG ve PNG Formatlarında Görsel Kullanınız", "warning");
        event.target.value = '';
        return false;
      }

      // Valid image
      this.imagePreview = false;
      imageSetter(file);
      return true;
    },
    startLoadingAnimation() {
      this.loadingProgress = 0;
      this.loadingInterval = setInterval(() => {
        if (this.loadingProgress < 90) {
          this.loadingProgress += 10;
        }
      }, 200);
    },

    onIframeLoad() {
      clearInterval(this.loadingInterval);
      this.loadingProgress = 100;
      setTimeout(() => {
        this.iframeLoaded = true;
      }, 200);
    },

    updateProfileAndReloadIframe() {
      this.updateProfile();
      this.reloadIframe();
    },

    reloadIframe() {
      this.iframeLoaded = false;
      this.startLoadingAnimation();
      if (this.$refs.userIframe) {
        this.$refs.userIframe.src = this.qrUserUrl;
      }
    },
    updateProfile() {
      const app_data = this
      // eslint-disable-next-line camelcase
      const form = new FormData()
      // Telefon numaralarını direkt atıyoruz
      app_data.user.phones[0].number =  app_data.user.personal_phone; // Personal phone
      app_data.user.phones[1].number =  app_data.user.business_phone; // Business phone
      app_data.user.phones[2].number =  app_data.user.other_phone;    // Other phone
      form.append('userInfo', JSON.stringify(app_data.user))
      form.append('background_img', app_data.backgroundImage)
      form.append('profile_img', app_data.profileImage)
      form.append('catalog_file', app_data.eCatalog)

      axios.defaults.headers.common.authorization = localStorage.getItem('authorization')
      axios.post(
        `${config.app_url}/user/update-user/?userHash=${JSON.parse(localStorage.getItem('userInfo')).userHash}`,
        form
      ).then(response => {
        if (response.data.success) {
          app_data.notifyVue('top', 'right', "Güncelleme Başarılı!", "success")
          this.reloadIframe();
        } else {
          app_data.notifyVue('top', 'right', "Güncelleme Başarısız!", "warning")
        }
      }).catch(error => {
        app_data.notifyVue('top', 'right', "Bağlantı Hatası!", "warning")
      })
    },
    getUser() {
      const app_data = this
      // eslint-disable-next-line camelcase
      axios.defaults.headers.common.authorization = localStorage.getItem('authorization')
      axios.get(
        `${config.app_url}/user/get-user`,
      ).then(response => {
        if (response.data.success) {
          app_data.user = response.data.msg
          app_data.userCards = response.data.msg.cards_info
          app_data.imageUrl = `${config.img_url}`
          app_data.imagePreview = true
          response.data.msg.background_img ? app_data.backgroundImageSrc = `${config.img_url}/${response.data.msg.background_img}` : app_data.backgroundImageSrc = "@/assets/img/background.jpg"
          response.data.msg.profile_img ? app_data.profileImageSrc = `${config.img_url}/${response.data.msg.profile_img}` : app_data.profileImageSrc = "@/assets/img/faces/face-2.jpg"
          response.data.msg.background_img ? app_data.backgroundImage = response.data.msg.background_img:null;
          response.data.msg.profile_img ? app_data.profileImage = response.data.msg.profile_img:null;
          response.data.msg.catalog_file ? app_data.eCatalog = response.data.msg.catalog_file:null;
          app_data.qrUserUrl = `${config.qr_url}/qr-user/?hash=${response.data.msg.userHash}`;
        } else {

        }
      }).catch(error => {
        router.push('login')
        app_data.$toast.error(error.toString());
      })
    },
    notifyVue(verticalAlign, horizontalAlign, message, type) {
      this.$notify({
        component: NotificationTemplate,
        title: message,
        icon: "info",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
        duration: 2000
      });
    },
    handleProfileImageChange(event) {
      this.validateAndHandleImage.call(this, event,
        (file) => this.profileImage = file,
        this.notifyVue
      );
    },

    handleBackgroundImageChange(event) {
      this.validateAndHandleImage.call(this, event,
        (file) => this.backgroundImage = file,
        this.notifyVue
      );
    },
    handleCatalogChange(event) {
      this.eCatalog = null
      this.eCatalog = event.target.files[0];

    },
    removeBackImage() {
      this.imagePreview = false
      this.backgroundImage = null
      this.backgroundImageSrc = null
    },
    removeProfileImage() {
      this.imagePreview = false
      this.profileImage = null
      this.profileImageSrc = null
    }

  },
};
const base64Encode = data => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.readAsDataURL(data)
  reader.onload = () => resolve(reader.result)
  reader.onerror = error => reject(error)
})
</script>
<style>
/* iPhone X benzeri çerçeve */
.iphone-x {
  width: 350px;
  height: 700px;
  max-width: 375px;
  max-height: 812px;
  background: #000;
  position: relative;
  border: 16px solid #222;
  border-radius: 44px;
  overflow: hidden;
}

.iframe-container {
  width: 100%;
  height: 100%;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.progress-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
}
</style>
